import { call, put } from 'redux-saga/effects';
import { sendError } from '../../../';
import { userOrdersHistoryData, userOrdersHistoryError, UserOrdersHistoryFetch } from '../actions';
import { appUrls } from '../../../../api-new/urls';
import api from '../../../../api-new/http';

export function* ordersHistorySaga(action: UserOrdersHistoryFetch) {
    try {
        const { pageIndex } = action.payload;
        const data = yield call(() =>
            api.get(`${appUrls.tradeURL}/assets`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('csrfToken')}`,
                },
            }),
        );
        let nextPageExists = false;
        yield put(userOrdersHistoryData({ list: data, nextPageExists, pageIndex }));
    } catch (error) {
        yield put(sendError({
            error,
            processingType: 'alert',
            extraOptions: {
                actionError: userOrdersHistoryError,
            },
        }));
    }
}
